import React from "react";
import { Button } from "../ui/button";
import { Magnetic } from "./_shared";

export default function BigCTA({ data }) {
  const cta = data || {};
  const eyebrow = cta.eyebrow ?? "By appointment";
  const quote =
    cta.quote ?? "A man's clothes should be an extension of his character, starting with the fit.";
  const body =
    cta.body ??
    "Private styling at our Ahmedabad atelier. Made-to-measure consultations, bespoke linen edits, and wardrobes that move with the way you live.";
  const buttonLabel = cta.button_label ?? "Request a Hand-Tailored Fit";
  const buttonEmail = cta.button_email ?? "asvasaclothing@gmail.com";
  const buttonSubject = cta.button_subject ?? "Hand-Tailored Fit Request";

  return (
    <section className="bg-[#1A1A1A] text-[#c3ba9e] py-24 md:py-36" data-testid="big-cta">
      <div className="max-w-4xl mx-auto text-center px-6">
        <p className="eyebrow text-[#c3ba9e]/60">{eyebrow}</p>
        <h2 className="font-serif-display text-3xl md:text-5xl italic mt-5 leading-[1.2]">
          "{quote}"
        </h2>
        <p className="text-[#c3ba9e]/65 mt-7 max-w-xl mx-auto text-[15px]">{body}</p>
        <Magnetic>
          <a href={`mailto:${buttonEmail}?subject=${encodeURIComponent(buttonSubject)}`}>
            <Button
              className="mt-12 bg-[#c3ba9e] text-[#1A1A1A] hover:bg-[#FDFAF6] rounded-none px-12 py-6 tracking-[0.22em] uppercase text-xs btn-shimmer"
              data-testid="book-appointment-btn"
            >
              {buttonLabel}
            </Button>
          </a>
        </Magnetic>
      </div>
    </section>
  );
}
